import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { addUpdateSeries } from "../api/addUpdateSeries";

export const useAddUpdateSeries = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body) => addUpdateSeries(body),
    onSuccess: () => {
      toast.success("Saved successfully.");
      queryClient.invalidateQueries({ queryKey: ["allSeries"] });
      queryClient.invalidateQueries({ queryKey: ["syncStatus"] });
      queryClient.invalidateQueries({ queryKey: ["pendingChanges", "material"] });
    },
    onError: () => {
      toast.error("Failed to save. Please try again.");
    },
  });
};

